export default __webpack_public_path__ + "static/media/semantic-ui.89f45c49.svg";